import { ChevronDown, Download, Image, Store, X } from "lucide-react";
import React, { useRef, useState } from "react";
import Input from "../../components/input/Input";
import { useTranslation } from "react-i18next";
import { createUploadFileOBJ, toBase64 } from "../../reusable/functions";
import Swal from "sweetalert2";

const YesNoEnum = {
  Yes: 1,
  No: 0,
};
const defaultValue = {
  FirstName: "",
  LastName: "",
  PhoneNumber: "",
  Email: "",
  NationalCode: "",
  StoreOrComapnyName: "",
  Province: "",
  City: "",
  StoreAddress: "",
  ActivityHistory: "",
  NumberOfTroops: "",
  StoreSpace: "",
  AreaOfCooperation: "",
  CurrentAverageMonthlySales: "",
  PartsWarehouse: "",
  MotorcycleCourier: "",
  NationalCodeAttachment: [],
  StoreAttachment: [],
  Attachment: [],
};

const RegistrationAgent = () => {
  const { t } = useTranslation();
  const fileInputRef = useRef();
  const nationalCodeInputRef = useRef();
  const storeInputRef = useRef();
  const [formData, setFormData] = useState(defaultValue);

  // Handle file upload
  const handleFileChange = async (e, fieldName) => {
    const selectedFiles = Array.from(e.target.files);

    // Check if the total files exceed 5
    if (formData[fieldName].length + selectedFiles.length > 5) {
      Swal.fire(t("error"), t("errorDesc"));
      return;
    }

    const updatedAttachments = await Promise.all(
      selectedFiles.map(async (file) => {
        const Base64 = await toBase64(file);
        return await createUploadFileOBJ(Base64, file);
      }),
    );

    setFormData((prevFormData) => ({
      ...prevFormData,
      [fieldName]: [
        ...prevFormData[fieldName],
        ...updatedAttachments.map((uploadedFile) => ({
          UploadedFile: uploadedFile,
        })),
      ],
    }));
  };

  const removeFile = (index, fieldName) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [fieldName]: prevFormData[fieldName].filter((_, i) => i !== index),
    }));
  };
  // Handle input changes
  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  return (
    <div className="flex flex-col items-center justify-center gap-5 w-full">
      <Store color="#1A2263" size={22} />
      <div className="flex flex-col items-center justify-center gap-2 lg:w-[900px]">
        <p className="text-PrimaryText text-lg font-bold">
          {t("addAgentTitle")}
        </p>
        <p>{t("addAgentText")} </p>
      </div>
      <div className="min-w-[370px] lg:w-[900px] bg-white rounded-[59px] py-8 px-5 lg:px-10 flex flex-col gap-5">
        <p className="text-PrimaryText font-medium text-[17px]">
          {t("PersonalInfo")}
        </p>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <Input
            name="FirstName"
            label={t("FirstName")}
            required
            bgWhite
            border
            value={formData.FirstName}
            onChange={handleChange}
          />
          <Input
            name="LastName"
            label={t("LastName")}
            required
            bgWhite
            border
            value={formData.LastName}
            onChange={handleChange}
          />
          <Input
            name="PhoneNumber"
            label={t("Phone")}
            required
            bgWhite
            border
            value={formData.PhoneNumber}
            onChange={handleChange}
          />
          <Input
            name="Email"
            label={t("Email")}
            bgWhite
            border
            value={formData.Email}
            onChange={handleChange}
          />
          <Input
            name="NationalCode"
            label={t("NationalCode")}
            bgWhite
            border
            value={formData.NationalCode}
            onChange={handleChange}
          />
        </div>
        <div className="w-full h-px bg-[#DEE4F0]" />
        <p className="text-PrimaryText font-medium text-[17px]">
          {t("businessInformation")}
        </p>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          <Input
            name="StoreOrComapnyName"
            label={t("StoreOrComapnyName")}
            required
            bgWhite
            border
            className="lg:col-span-6"
            value={formData.StoreOrComapnyName}
            onChange={handleChange}
          />
          <Input
            name="Province"
            label={t("Province")}
            required
            bgWhite
            border
            className="lg:col-span-2"
            value={formData.Province}
            onChange={handleChange}
          />
          <Input
            name="City"
            label={t("City")}
            required
            bgWhite
            border
            className="lg:col-span-4"
            value={formData.City}
            onChange={handleChange}
          />
          <Input
            name="StoreAddress"
            label={t("StoreAddress")}
            bgWhite
            border
            className="lg:col-span-12"
            value={formData.StoreAddress}
            onChange={handleChange}
          />
          <Input
            name="ActivityHistory"
            label={t("ActivityHistory")}
            bgWhite
            border
            className="lg:col-span-4"
            value={formData.ActivityHistory}
            onChange={handleChange}
          />
          <Input
            name="NumberOfTroops"
            label={t("NumberOfTroops")}
            bgWhite
            border
            className="lg:col-span-4"
            value={formData.NumberOfTroops}
            onChange={handleChange}
          />
          <Input
            name="StoreSpace"
            label={t("StoreSpace")}
            bgWhite
            border
            className="lg:col-span-4"
            value={formData.StoreSpace}
            onChange={handleChange}
          />
          <Input
            name="AreaOfCooperation"
            label={t("AreaOfCooperation")}
            bgWhite
            border
            className="lg:col-span-4"
            value={formData.AreaOfCooperation}
            onChange={handleChange}
          />
        </div>
        <div className="w-full h-px bg-[#DEE4F0]" />
        <p className="text-PrimaryText font-medium text-[17px]">
          {t("financialAndLogisticalConditions")}
        </p>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <Input
            name="CurrentAverageMonthlySales"
            label={t("CurrentAverageMonthlySales")}
            required
            bgWhite
            border
            value={formData.CurrentAverageMonthlySales}
            onChange={handleChange}
          />
          <Select
            id="PartsWarehouse"
            name="PartsWarehouse"
            title={t("PartsWarehouse")}
            placeholder={t("chooseOneItem")}
            optionsEnum={YesNoEnum}
            value={formData.PartsWarehouse}
            isRequired
            onChange={handleChange}
          />

          <Select
            id="MotorcycleCourier"
            name="MotorcycleCourier"
            title={t("MotorcycleCourier")}
            placeholder={t("chooseOneItem")}
            optionsEnum={YesNoEnum}
            value={formData.MotorcycleCourier}
            onChange={handleChange}
          />
        </div>
        <div className="w-full h-px bg-[#DEE4F0]" />
        <p className="text-PrimaryText font-medium text-[17px]">
          {t("uploadFile")}
        </p>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="flex flex-col items-center justify-center gap-3">
            {formData.NationalCodeAttachment?.length > 0 && (
              <div className="border-2 border-[#F3F4F6] rounded-[31px] p-3 max-w-[270px]">
                <div className="flex items-center justify-between gap-2">
                  <p className="text-PrimaryText font-medium text-[15px]">
                    {t("nationalCodeFile")}
                    <span className="text-red-500">*</span>
                  </p>
                  <div>
                    <div
                      onClick={() => nationalCodeInputRef.current.click()}
                      className="text-white bg-primary w-10 h-10 rounded-full flex items-center justify-center cursor-pointer"
                    >
                      <Download />
                    </div>
                  </div>
                </div>
                <div className="grid grid-cols-3 mt-4 gap-2">
                  {formData.NationalCodeAttachment.map((attachment, index) => (
                    <div
                      key={index}
                      className="flex justify-center items-center relative"
                    >
                      <img
                        src={attachment.UploadedFile.Content}
                        alt="title"
                        className="w-[64px] h-[64px] rounded-2xl object-cover"
                      />
                      <X
                        size={34}
                        onClick={() =>
                          removeFile(index, "NationalCodeAttachment")
                        }
                        className="absolute -top-3 -left-2 border-4 border-white rounded-full text-primary bg-[#FBCFC8] p-1"
                      />
                    </div>
                  ))}
                </div>
              </div>
            )}
            {!formData.NationalCodeAttachment?.length > 0 && (
              <>
                <div className="flex items-center justify-center rounded-2xl w-20 h-20 bg-[#F1F5F9]">
                  <Image />
                </div>
                <p className="text-PrimaryText font-medium text-[15px]">
                  {t("nationalCodeFile")}
                  <span className="text-red-500">*</span>
                </p>
                <div
                  onClick={() => nationalCodeInputRef.current.click()}
                  className="text-primary bg-[#FBCFC8] w-48 h-14 flex items-center justify-center rounded-full text-[15px] font-medium cursor-pointer"
                >
                  {t("addFile")}
                </div>
              </>
            )}
          </div>
          <input
            type="file"
            name="nationalCodeFile"
            ref={nationalCodeInputRef}
            className="hidden"
            onChange={(e) => {
              handleFileChange(e, "NationalCodeAttachment");
            }}
          />
          <div className="flex flex-col items-center justify-center gap-3">
            {formData.StoreAttachment?.length > 0 && (
              <div className="border-2 border-[#F3F4F6] rounded-[31px] p-3 max-w-[270px]">
                <div className="flex items-center justify-between gap-2">
                  <p className="text-PrimaryText font-medium text-[15px]">
                    {t("storeFile")}
                    <span className="text-red-500">*</span>
                  </p>
                  <div>
                    <div
                      onClick={() => storeInputRef.current.click()}
                      className="text-white bg-primary w-10 h-10 rounded-full flex items-center justify-center cursor-pointer"
                    >
                      <Download />
                    </div>
                  </div>
                </div>
                <div className="grid grid-cols-3 mt-4 gap-2">
                  {formData.StoreAttachment.map((attachment, index) => (
                    <div
                      key={index}
                      className="flex justify-center items-center relative"
                    >
                      <img
                        src={attachment.UploadedFile.Content}
                        alt="title"
                        className="w-[64px] h-[64px] rounded-2xl object-cover"
                      />
                      <X
                        size={34}
                        onClick={() => removeFile(index, "StoreAttachment")}
                        className="absolute -top-3 -left-2 border-4 border-white rounded-full text-primary bg-[#FBCFC8] p-1"
                      />
                    </div>
                  ))}
                </div>
              </div>
            )}
            {!formData.StoreAttachment?.length > 0 && (
              <>
                <div className="flex items-center justify-center rounded-2xl w-20 h-20 bg-[#F1F5F9]">
                  <Image />
                </div>
                <p className="text-PrimaryText font-medium text-[15px]">
                  {t("storeFile")}
                  <span className="text-red-500">*</span>
                </p>
                <div
                  onClick={() => storeInputRef.current.click()}
                  className="text-primary bg-[#FBCFC8] w-48 h-14 flex items-center justify-center rounded-full text-[15px] font-medium cursor-pointer"
                >
                  {t("addFile")}
                </div>
              </>
            )}
          </div>
          <input
            type="file"
            name="storeFile"
            ref={storeInputRef}
            className="hidden"
            onChange={(e) => {
              handleFileChange(e, "StoreAttachment");
            }}
          />
          <div className="flex flex-col items-center justify-center gap-3">
            {formData.Attachment?.length > 0 && (
              <div className="border-2 border-[#F3F4F6] rounded-[31px] p-3 max-w-[270px]">
                <div className="flex items-center justify-between gap-2">
                  <p className="text-PrimaryText font-medium text-[15px]">
                    {t("businessLicenseFile")}
                    <span className="text-red-500">*</span>
                  </p>
                  <div>
                    <div
                      onClick={() => fileInputRef.current.click()}
                      className="text-white bg-primary w-10 h-10 rounded-full flex items-center justify-center cursor-pointer"
                    >
                      <Download />
                    </div>
                  </div>
                </div>
                <div className="grid grid-cols-3 mt-4 gap-2">
                  {formData.Attachment.map((attachment, index) => (
                    <div
                      key={index}
                      className="flex justify-center items-center relative"
                    >
                      <img
                        src={attachment.UploadedFile.Content}
                        alt="title"
                        className="w-[64px] h-[64px] rounded-2xl object-cover"
                      />
                      <X
                        size={34}
                        onClick={() => removeFile(index, "Attachment")}
                        className="absolute -top-3 -left-2 border-4 border-white rounded-full text-primary bg-[#FBCFC8] p-1"
                      />
                    </div>
                  ))}
                </div>
              </div>
            )}
            {!formData.Attachment?.length > 0 && (
              <>
                <div className="flex items-center justify-center rounded-2xl w-20 h-20 bg-[#F1F5F9]">
                  <Image />
                </div>
                <p className="text-PrimaryText font-medium text-[15px]">
                  {t("businessLicenseFile")}
                  <span className="text-red-500">*</span>
                </p>
                <div
                  onClick={() => fileInputRef.current.click()}
                  className="text-primary bg-[#FBCFC8] w-48 h-14 flex items-center justify-center rounded-full text-[15px] font-medium cursor-pointer"
                >
                  {t("addFile")}
                </div>
              </>
            )}
          </div>
          <input
            type="file"
            name="File"
            ref={fileInputRef}
            className="hidden"
            onChange={(e) => {
              handleFileChange(e, "Attachment");
            }}
          />
        </div>
        <div className="w-full h-px bg-[#DEE4F0]" />
        <div className="flex flex-col lg:flex-row items-center gap-6">
          <p className="text-PrimaryText text-[15px]">{t("addAgentDesc")}</p>
          <button className="rounded-full w-48 h-12 flex items-center justify-center text-white bg-primary">
            {t("sendRequest")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RegistrationAgent;

const Select = ({
  name,
  title,
  isRequired,
  optionsEnum,
  onChange,
  value,
  placeholder,
}) => {
  const { t, i18n } = useTranslation();

  return (
    <div className="flex flex-col gap-[15px]">
      <label htmlFor={name} className="text-sm">
        {title}
        {isRequired && <span className="text-red-600">*</span>}:
      </label>

      <div className="relative">
        <select
          id={name}
          name={name}
          required={isRequired}
          onChange={onChange}
          value={value}
          className="
            w-full bg-white rounded-full outline-none h-[49px]
            border border-[#E5E7EB]
            px-4 appearance-none
          "
        >
          <option value="">{placeholder}</option>

          {Object.entries(optionsEnum).map(([key, value]) => (
            <option key={value} value={value}>
              {t(key)}
            </option>
          ))}
        </select>

        <div
          className={`absolute top-[35%] -translate-y-1/2 pointer-events-none ${
            i18n.dir() === "rtl" ? "left-4" : "right-4"
          }`}
        >
          <ChevronDown size={20} className="text-primary" />
        </div>
      </div>
    </div>
  );
};
